export default __webpack_public_path__ + "static/media/avatar_18.6c5da5e0.png";